// extracted by mini-css-extract-plugin
export default {"titleBlock":"layout_titleBlock__z33i+","pageTitle":"layout_pageTitle__SiomZ","header":"layout_header__FH6Sz","content":"layout_content__Kno22"};